/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AppointmentSettingsDto } from './appointment-settings-dto';
import { ServiceFormFieldDto } from './service-form-field-dto';
/**
 * 
 * @export
 * @interface UpdateServiceFormDto
 */
export interface UpdateServiceFormDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceFormDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceFormDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceFormDto
     */
    category?: UpdateServiceFormDtoCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateServiceFormDto
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateServiceFormDto
     */
    duration?: number;
    /**
     * 
     * @type {Array<ServiceFormFieldDto>}
     * @memberof UpdateServiceFormDto
     */
    fields?: Array<ServiceFormFieldDto>;
    /**
     * 
     * @type {AppointmentSettingsDto}
     * @memberof UpdateServiceFormDto
     */
    appointment?: AppointmentSettingsDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateServiceFormDto
     */
    isActive?: boolean;
    /**
     * When true, the questionnaire comes from the store shared consent template (vaccines). Set false for a custom form with its own fields.
     * @type {boolean}
     * @memberof UpdateServiceFormDto
     */
    usesSharedForm?: boolean;
    /**
     * Create from a catalog template; missing name/fields are copied from it
     * @type {string}
     * @memberof UpdateServiceFormDto
     */
    catalogKey?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateServiceFormDtoCategoryEnum {
    Vaccine = 'vaccine',
    Test = 'test',
    Consultation = 'consultation',
    Treatment = 'treatment',
    Other = 'other'
}

